
<template>
  <div>
    
    <a v-bind:href="apiUrl"><font-awesome-icon icon="home" size="2x" /></a> 

    <div class="container">  
        <div class="box has-background-light" >

        <h1 class="title is-3 has-text-centered has-text-info">Confirmation de publication</h1>

          <br /> 
          <br /> 
          <p> 

          <b>Lien vers l'annonce :</b>
          <br />          
          <a v-bind:href="linkjob">{{jobtitre}}</a> 
          <br /> 
          <br /> 

          <b>Paiement numéro :</b>
          <br /> 
          {{id}}
          <br /> 
          <br /> 

          <b>État du paiement :</b>
          <br /> 
          {{status}}
          <br /> 
          <br /> 

          <b>Moyen de paiement : </b>
          <br /> 
          Carte de crédit
          <br /> 
          <br /> 

          <b>Prix TTC : </b>
          <br /> 
          {{price_cur}} 
          <br /> 
          <br /> 

          </p> 

        </div>
    </div>

  </div>    
</template>

<script>
import axios from 'axios';
export default {
      data: function() {
        return {
         sessionId: this.$route.query.session_id,
         apiUrl: '',
         id: '',
         price_cur: '',
         linkjob: '',
         jobtitre: ''
       };
      },
      methods: {
        checkSession () {
          var api_url = this.apiUrl+'/sessiondata/'+this.sessionId;
          axios.get(api_url)
          .then(response => {
            this.id = response.data.id;
            this.linkjob = response.data.linkjob;
            this.jobtitre = response.data.jobtitre;
            this.status = response.data.status;
            this.price_cur = response.data.price + " " + response.data.currency
           })
          .catch(error => {
            console.log(error)
          })
        }
      }
      ,
      created () {
        this.checkSession();
        this.apiUrl = process.env.API_URL;
      }
    };

</script>





// WEBPACK FOOTER //
// src/components/Checkoutsuccess.vue